export const FORM_PROVIDER_READONLY_LABEL = 'readonly-label';
